.list {
  padding: 16px 24px;
  display: flex;
  flex-direction: column-reverse;
  overflow-y: auto;
  gap: 16px;
  scrollbar-color: var(--vkui--color_icon_tertiary_alpha) transparent;
  scrollbar-width: thin;
  flex: 1 0;
  height: 100%;
}

.trigger {
  padding: 16px;
  text-align: center;
}
